(() => {
  try {

    const getLocale = () => {
      const lang = document.documentElement.lang;
      return lang ? lang.substring(0,2) : "fr";
    };

   const translations = {
  fr: {
    standard: "Livraison Standard",
    free: "Livraison Offerte"
  },
  it: {
    standard: "Spedizione Standard",
    free: "Spedizione Gratuita"
  },
  es: {
    standard: "Envío Estándar",
    free: "Envío Gratis"
  }
};

    const setUI = (isFree) => {
      const wrapper = document.getElementById("kx-shipping-line");
      const textEl = document.getElementById("kx-shipping-text");
      if (!wrapper || !textEl) return;

      const locale = getLocale();
      const t = translations[locale] || translations.fr;

      textEl.classList.add("kx-fade");

      setTimeout(() => {
        if (isFree) {
          textEl.textContent = t.free;
          wrapper.classList.add("free");
        } else {
          textEl.textContent = t.standard;
          wrapper.classList.remove("free");
        }

        textEl.classList.remove("kx-fade");
        textEl.classList.add("kx-fade-in");

        setTimeout(() => {
          textEl.classList.remove("kx-fade-in");
        }, 250);

      }, 120);
    };

    const hasFreeShippingGift = () => {
  const checked = document.querySelector(
    "input[type='radio'][name^='kaching-bundles-deal']:checked"
  );
  if (checked) {
    const label = document.querySelector(`label[for='${checked.id}']`);
    if (label) {
      const text = label.textContent.toLowerCase();

      // 1) cadeau explicite "livraison" (si un futur bundle l'utilise)
      const freeGift = label.querySelector(".kaching-bundles__free-gift__text");
      if (freeGift) {
        const giftText = freeGift.textContent.toLowerCase();
        if (giftText.includes("livraison") || giftText.includes("spedizione")) {
          return true;
        }
      }

      // 2) le tier "Protection Complète" inclut la livraison offerte
      if (text.includes("protection complète") || text.includes("protezione completa")) {
        return true;
      }
    }
  }

  // 3) fallback quantité (utile si un futur bundle repose sur la quantité)
  const qtyInput = document.querySelector("input[name='quantity']");
  if (qtyInput) {
    const qty = parseInt(qtyInput.value, 10);
    if (!isNaN(qty) && qty >= 2) return true;
  }

  return false;
};

    const update = () => {
      const isFree = hasFreeShippingGift();
      setUI(isFree);
    };

    const boot = () => {
      update();

      document.addEventListener("change", (e) => {
        if (
          e.target.matches("input[type='radio'][name^='kaching-bundles-deal']")
        ) {
          // Kaching met à jour l'input quantity un poil après le change event,
          // on attend un tick pour être sûr de lire la bonne valeur
          setTimeout(update, 50);
        }
      });
    };

    let tries = 0;
    const t = setInterval(() => {
      tries++;
      if (
        document.querySelector("input[type='radio'][name^='kaching-bundles-deal']")
        || tries > 50
      ) {
        clearInterval(t);
        boot();
      }
    }, 200);

  } catch (e) {
    console.warn("[kx-shipping-line disabled]", e);
  }
})();